import { computed, inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

const APP_URL = 'https://app.amlofficer.org';
const REGISTER_URL = `${APP_URL}/register-corporate-account`;

/**
 * Single place for the links into the business account application.
 * Keeps the referral/tracking parameters that app.component.ts stores in localStorage,
 * and falls back to the plain URLs on the server, where localStorage does not exist.
 */
@Injectable({
  providedIn: 'root',
})
export class AppLinksService {
  private readonly _platformId = inject(PLATFORM_ID);

  readonly createAccountHref = computed(() => this._withTrackingParams(REGISTER_URL));

  readonly loginHref = computed(() => this._withTrackingParams(APP_URL));

  private _withTrackingParams(url: string): string {
    if (!isPlatformBrowser(this._platformId)) {
      return url;
    }

    const referralLink = localStorage.getItem('referralLink');
    const trackingLink = localStorage.getItem('trackingLink');
    const queryParams = new URLSearchParams();
    if (referralLink) {
      queryParams.set('referralLink', referralLink);
    }
    if (trackingLink) {
      queryParams.set('trackingLink', trackingLink);
    }
    const query = queryParams.toString();
    return query ? `${url}?${query}` : url;
  }
}
